// extracted by mini-css-extract-plugin
export default {"redMenuItem":"hooks_redMenuItem__3gHRq"};